import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetMegaMenuCategories } from "../../../services/megaMenuService";

export const fetchMegamenuData = createAsyncThunk(
  "megamenu/fetchMegamenuData",
  async (_, { rejectWithValue }) => {
    try {
      const data = await GetMegaMenuCategories();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const megamenuSlice = createSlice({
  name: "megamenu",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMegamenuData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMegamenuData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || []; //  safe
      })
      .addCase(fetchMegamenuData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default megamenuSlice.reducer;